import React, { Component } from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import {
  Row,
  FormGroup,
  Col,
  FormControl,
  Form,
  Container,
  InputGroup
} from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import LogoDropzone from './LogoDropzone';
import FaviconDropzone from './FaviconDropzone';
import Loader from '../../Common/Loader';
import SwitchButton from './Switch';

import s from './SiteSettingsForm.css';

import { siteSettings } from '../../../actions/siteadmin/SiteSettings/siteSettings';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { api, logoUploadDir, faviconUploadDir, siteUrl } from '../../../config';

//image
import defaultIcon from '../../../../public/Icons/defaultIconAdmin.svg';
export class SiteSettingsForm extends Component {

  static defaultProps = {
    loading: false,
    updateSiteSettings: false
  };

  renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cx(s.space2, 'positionRelative')}>
        <label className={'inputLabel'}>{label}</label>
        <FormControl {...input} placeholder={label} type={type} className={cx(className, s.formControlInput)} maxLength={maxlength} />
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  renderAddonFormControl = ({ input, label, type, meta: { touched, error }, className, maxlength, addonLabel }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('inputFormAddon', 'addonBorder')}>
        <Form.Group>
          <label className={s.labelText} >{label}</label>
          <InputGroup>
          <FormControl {...input} placeholder={label} type={type} className={s.formControlInput} maxLength={maxlength} />
              <InputGroup.Text>{addonLabel}</InputGroup.Text>
          </InputGroup>
          {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
        </Form.Group>
      </div>
    );
  }

  renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cx(s.space2, 'positionRelative')}>
        <label className={'inputLabel'}>{label}</label>
        <FormControl
          {...input}
          className={className}
          placeholder={label}
          as="textarea"
          rows='4'
        >
          {children}
        </FormControl>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  renderSelectField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children }) => {
    return (
      <Form.Group className={cx(s.space2, 'positionRelative')}>
        <Form.Label className={'inputLabel'}>{label}</Form.Label>
        <Form.Control as="select" {...input} placeholder={placeholder} className={fieldClass}>
          {children}
        </Form.Control>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{error.defaultMessage}</span>}
      </Form.Group>
    )
  }
  renderFieldApp = ({ input, label, type, meta: { touched, error }, className, maxlength }) => {
    return (
      <div className={cx('inputFormAddon', 'addonBorder', 'positionRelative')}>
        <Form.Group>
          <label className={'inputLabel'}>{label}</label>
          <InputGroup>
            <InputGroup.Append>
              <InputGroup.Text>
                V
              </InputGroup.Text>
            </InputGroup.Append>
            <FormControl {...input} placeholder={label} type={type} className={s.formControlInput} maxLength={maxlength} />
          </InputGroup>
          {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{error.defaultMessage}</span>}
        </Form.Group>
      </div>
    )
  }

  renderSwitch = ({ input, meta: { touched, error }, switchOnLabel, switchOffLabel }) => {
    const { formatMessage } = this.props.intl;
    input.value = input.value == "0" ? false : true;

    return (
      <SwitchButton
        {...input}
        defaultValue={input.value}
        switchOnLabel={switchOnLabel}
        switchOffLabel={switchOffLabel}
      />
    )
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { handleSubmit, logo, loading, submitting, updateSiteSettings, appForceUpdate, favicon } = this.props;

    return (
      <div className={s.paddignLeftRight}>
        <Container fluid>
          <form onSubmit={handleSubmit(submit)}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} className={s.space5}>

                {/* Section 1: Brand & Identity */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.brandIdentitySection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <div className={cx(s.profileImgSection, s.space2)}>
                      <label>{formatMessage(messages.logo)}</label>
                      {logo &&
                        <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + logoUploadDir}${logo})` }} />
                      }
                      {
                        !logo &&
                        <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                      }
                      <div>
                        <LogoDropzone
                          className={cx(s.btnSecondary, s.profileNoPadding)}
                          subTextClass={s.subText}
                          subText={formatMessage(messages.maximumUploadSizeLabel)}
                          defaultMessage={formatMessage(messages.chooseFile)}
                        />
                      </div>
                    </div>
                    <div className={cx(s.profileImgSection, s.space2)}>
                      <label className={s.labelText}>{formatMessage(messages.favIconlogoLabel)}</label>
                      {favicon &&
                        <div className={s.backgroundImg} style={{ backgroundImage: `url(${siteUrl + faviconUploadDir + favicon})` }} />
                      }
                      {
                        !favicon &&
                        <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                      }
                      <div className={'commonFilepicker'}>
                        <FaviconDropzone
                          className={cx(s.btnSecondary, 'fileNoPadding')}
                          subTextClass={s.subText}
                          subText={formatMessage(messages.maximumUploadSizeLabel)}
                          defaultMessage={formatMessage(messages.chooseFile)}
                        />
                      </div>
                    </div>
                    <Field name="logoWidth" type="text" component={this.renderFormControl} label={formatMessage(messages.logoWidth)} />
                    <Field name="logoHeight" type="text" component={this.renderFormControl} label={formatMessage(messages.logoHeight)} />
                    <Field name="siteName" type="text" component={this.renderFormControl} label={formatMessage(messages.siteNameLabel)} maxLength={250} />
                    <Field name="siteTitle" type="text" component={this.renderFormControl} label={formatMessage(messages.siteTitleLabel)} />
                  </div>
                </div>

                {/* Section 2: SEO */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.seoSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Field name="metaKeyword" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.metaKeywordLabel)} />
                    <Field name="metaDescription" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.metaDescriptionLabel)} />
                  </div>
                </div>

                {/* Section 3: Social Media */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.socialMediaSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Field name="facebookLink" type="text" component={this.renderFormControl} label={formatMessage(messages.facebookURLLabel)} />
                    <Field name="twitterLink" type="text" component={this.renderFormControl} label={formatMessage(messages.twitterURLLabel)} />
                    <Field name="instagramLink" type="text" component={this.renderFormControl} label={formatMessage(messages.instagramURLLabel)} />
                    <Field name="youtubeLink" type="text" component={this.renderFormControl} label={formatMessage(messages.youtubeURLLabel)} />
                  </div>
                </div>

                {/* Section 4: Contact Information */}
                <div className={s.sectionCard}>
                  <div className={s.sectionHeader}>
                    <div className={s.sectionTitle}>{formatMessage(messages.contactInfoSection)}</div>
                  </div>
                  <div className={s.sectionGrid}>
                    <Field name="contactNumber" type="text" component={this.renderFormControl} label={formatMessage(messages.contactNumber)} />
                    <Field name="contactEmail" type="text" component={this.renderFormControl} label={formatMessage(messages.contactEmail)} />
                    <Field name="contactSkype" type="text" component={this.renderFormControl} label={formatMessage(messages.contactSkype)} />
                  </div>
                </div>

                <div className={cx(s.textAlignRight, 'textAlignLeftRTL')}>
                  <Loader
                    type={"button"}
                    label={formatMessage(messages.submitButton)}
                    show={updateSiteSettings || submitting}
                    buttonType={'submit'}
                    className={cx(s.button, s.btnPrimary)}
                    disabled={updateSiteSettings || submitting}
                    isSuffix={true}
                  />
                </div>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    )
  }
}

const callSiteSettings = async (result, dispatch, props) => {
  const { refetch } = props
  await refetch()
  dispatch(siteSettings())
}

SiteSettingsForm = reduxForm({
  form: 'SiteSettingsForm',
  onSubmit: submit,
  validate,
  onSubmitSuccess: callSiteSettings
})(SiteSettingsForm);

const selector = formValueSelector('SiteSettingsForm')
const mapState = (state) => ({
  logo: selector(state, 'homeLogo'),
  appForceUpdate: selector(state, 'appForceUpdate'),
  favicon: selector(state, 'favicon'),
  updateSiteSettings: state.siteSettings.updateSiteSettings
})

const mapDispatch = {
  siteSettings
}

export default injectIntl(
  compose(
    withStyles(s),
    connect(mapState, mapDispatch),
  )(SiteSettingsForm));